export default {
  indicator: {
    height: '0px'
  }
}
